import Typography from "@mui/material/Typography";
import {Button, MenuItem, Select, Stack, TextField} from "@mui/material";
import {useContext, useState} from "react";
import {hasPermission} from "../../../utils/permissionUtils";
import {AuthContext} from "../../../context/AuthContext";
import {hasFormChanged, zodSubmit} from "../../../utils/FormUtils";
import DisabledWrapper from "../../../components/DisabledWrapper";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import {z} from "zod";


const General = ({data, handleSubmit}) => {
    const {getUser} = useContext(AuthContext);
    const user = getUser()
    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);


    const canUpdateRole = hasPermission(user, 'colleague', 'update') && data.role !== 'owner';

    let schema = z.object({
        last_name: z.string().min(1, "A vezetéknév kötelező"),
        first_name: z.string().min(1, "A keresztnév kötelező"),
        title: z.string().min(1, "A titulus/foglalkozás kötelező"),
    });

    if (canUpdateRole) {
        schema = schema.extend({
            role: z.enum(['employee', 'manager'], { required_error: 'Szerepkör kötelező' })
        });
    }

    return <form
        onSubmit={e => setIsDirty(!zodSubmit(e, setErrors, handleSubmit, schema))}
        onChange={e => setIsDirty(hasFormChanged(e.currentTarget, data))}
    >
        <Stack spacing={1} marginTop={2} marginBottom={2}>

            <Typography variant='caption' color='primary.main'>
                Vezetéknév*
            </Typography>
            <TextField
                defaultValue={data?.last_name}
                error={!!errors?.last_name}
                helperText={errors?.last_name}
                name='last_name'
                variant='standard'
            />

            <Typography variant='caption' color='primary.main'>
                Kersztnév*
            </Typography>
            <TextField
                defaultValue={data?.first_name}
                error={!!errors?.first_name}
                helperText={errors?.first_name}
                name='first_name'
                variant='standard'
            />

            <Typography variant='caption' color='primary.main'>
                Titulus/Foglalkozás*
            </Typography>
            <TextField
                defaultValue={data?.title}
                error={!!errors?.title}
                helperText={errors?.title}
                name='title'
                variant='standard'
            />

            {canUpdateRole && <>
                <Typography variant='caption' color='primary.main'>
                    Szerepkör*
                </Typography>
                <Select
                    defaultValue={data?.role}
                    error={!!errors?.role}
                    helperText={errors?.role}
                    name='role'
                    variant='standard'
                >
                    <MenuItem value='employee'>Alkalmazott</MenuItem>
                    <MenuItem value='manager'>Menedzser</MenuItem>
                </Select>
            </>}
            <DisabledWrapper disabledCause={[{
                disabled: !isDirty,
                message: 'Módosítsd a mezőket a mentéshez!'
            }]}>
                <Button
                    endIcon={<SaveRoundedIcon/>}
                    type="submit"
                    sx={{mt: 1}}
                    variant='contained'
                >
                    Módosítások mentése
                </Button>
            </DisabledWrapper>
        </Stack>
    </form>
}

export default General